import { render, staticRenderFns } from "./wg.vue?vue&type=template&id=1f2e3e0f&scoped=true&"
import script from "./wg.vue?vue&type=script&lang=js&"
export * from "./wg.vue?vue&type=script&lang=js&"
import style0 from "./wg.vue?vue&type=style&index=0&id=1f2e3e0f&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2e3e0f",
  null
  
)

export default component.exports